var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConferenceSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 6C22.1642 6 22.5 6.33579 22.5 6.75V16.75C22.5 17.1642 22.1642 17.5 21.75 17.5C21.3358 17.5 21 17.1642 21 16.75V6.75C21 6.33579 21.3358 6 21.75 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 6C2.16421 6 2.5 6.33579 2.5 6.75V16.75C2.5 17.1642 2.16421 17.5 1.75 17.5C1.33579 17.5 1 17.1642 1 16.75V6.75C1 6.33579 1.33579 6 1.75 6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 2C5.23122 2 4 3.23122 4 4.75V18.75C4 20.2688 5.23122 21.5 6.75 21.5H16.75C18.2688 21.5 19.5 20.2688 19.5 18.75V4.75C19.5 3.23122 18.2688 2 16.75 2H6.75ZM11.7508 6.08598C10.37 6.08598 9.25 7.20493 9.25 8.58597C9.25 9.96702 10.37 11.086 11.7508 11.086C13.1316 11.086 14.2516 9.96702 14.2516 8.58597C14.2516 7.20493 13.1316 6.08598 11.7508 6.08598ZM11.7516 12.0003C9.40384 12.0003 7.5 13.9027 7.5 16.2503C7.5 16.6645 7.83579 17.0003 8.25 17.0003H15.2532C15.6675 17.0003 16.0032 16.6645 16.0032 16.2503C16.0032 13.9027 14.0994 12.0003 11.7516 12.0003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConferenceSolidStandard);
export default __webpack_public_path__ + "static/media/conference-solid-standard.165380b3f8ea813641a0b6b2de7aac17.svg";
export { ForwardRef as ReactComponent };